<template>
  <div class="flex flex-col items-center px-8 pt-6 pb-12 mx-auto w-full sm:w-4/5 md:px-8 md:w-2/3">
    <div class="flex flex-col justify-center items-center w-full">
      <NuxtPage />
    </div>
  </div>
</template>
